import React, { useEffect, useMemo, useState } from 'react';
import { RadioButtonSet } from 'src/components/Quiz/RadioButtonSet';
import { Footer } from 'src/components/Quiz/Footer';
import { trackEvent } from 'src/services/analytics';
import { QuizQuestion } from 'src/components/Quiz/QuizQuestion';
import {
	AnswerKeys,
	EducationValues,
	QuizAnalytics,
	ScreenProps,
} from '@src/containers/QuizContainer/types';
import { useQuiz } from '@src/components/Providers/QuizProvider';
import styles from './Education.module.scss';

export const values: { label: EducationValues; disabled: boolean }[] = [
	{ label: EducationValues['Some high school'], disabled: false },
	{ label: EducationValues['High school diploma'], disabled: false },
	{ label: EducationValues['Some college credits'], disabled: false },
	{ label: EducationValues['Associate degree'], disabled: false },
	{ label: EducationValues["Bachelor's degree"], disabled: false },
	{ label: EducationValues["Master's degree or higher"], disabled: false },
];

const question = "What's your highest level of education?";

export const Education: React.FC<ScreenProps> = props => {
	const { answers } = useQuiz();
	const { defaultAnswers, nextScreen, previousScreen, updateAnswers } = props;
	const defaultAnswer = answers?.education
		? answers.education
		: defaultAnswers?.education || undefined;
	const [educationAnswer, setEducationAnswer] = useState<string>(defaultAnswer);

	const analyticsData: QuizAnalytics = useMemo(() => {
		return {
			questionKey: question,
			questionType: 'radioButtons',
		};
	}, []);

	useEffect(() => {
		setEducationAnswer(defaultAnswer);
	}, [defaultAnswer]);

	useEffect(() => {
		updateAnswers({ [AnswerKeys.education]: educationAnswer }, answers);
	}, [answers, educationAnswer, updateAnswers]);

	useEffect(() => {
		trackEvent('userProgramQuizQuestionAttempted', analyticsData);
	}, [analyticsData]);

	return (
		<>
			<fieldset className={styles.container} data-testid='education-background'>
				<legend className={styles.title}>
					<QuizQuestion question={question} />
				</legend>
				<RadioButtonSet onSelect={setEducationAnswer} options={values} value={educationAnswer} />
			</fieldset>
			<Footer
				disableNext={!educationAnswer}
				onClickNext={() => {
					analyticsData.responseKey = educationAnswer;
					updateAnswers({ [AnswerKeys.education]: educationAnswer }, answers);
					trackEvent('userProgramQuizQuestionCompleted', analyticsData);
					nextScreen();
				}}
				onClickPrevious={previousScreen}
			/>
		</>
	);
};
